import { render, staticRenderFns } from "./removeFormat.vue?vue&type=template&id=f42bbab8&scoped=true&"
import script from "./removeFormat.vue?vue&type=script&lang=js&"
export * from "./removeFormat.vue?vue&type=script&lang=js&"
import style0 from "./removeFormat.vue?vue&type=style&index=0&id=f42bbab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42bbab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
